import type { ReactNode } from 'react';

/**
 * `ts_headline` marks matches with literal `<b>…</b>` (`AM-132 point 8`); this renders exactly
 * those two tokens as `<strong>` and treats everything else as plain text - never
 * `dangerouslySetInnerHTML` with the raw string, so a snippet cannot inject markup of its own.
 */
export function renderHighlightedSnippet(text: string): ReactNode {
  const parts = text.split(/(<b>|<\/b>)/g);
  let bold = false;
  const nodes: ReactNode[] = [];

  parts.forEach((part, index) => {
    if (part === '<b>') {
      bold = true;
      return;
    }
    if (part === '</b>') {
      bold = false;
      return;
    }
    if (part.length === 0) {
      return;
    }
    nodes.push(bold ? <strong key={index}>{part}</strong> : <span key={index}>{part}</span>);
  });

  return nodes;
}
